import {Component, Inject} from "@angular/core";
import {FelloVisitorVariables, HomeConditionLevel, HomeConditionLevelLabel} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {GlobalTrackingEventService, TrackedEvents} from "fello-common";

export interface AreaConditionOption {
  name: string;
  value: HomeConditionLevel | null;
  description: string;
  image: string;
}

export const AREA_CONDITION_OPTIONS: AreaConditionOption[] = [
  {
    name: "Perfect",
    value: HomeConditionLevel.PERFECT,
    description: "Like new condition",
    image: "perfect"
  },
  {
    name: "Excellent",
    value: HomeConditionLevel.EXCELLENT,
    description: "Excellent & well maintained",
    image: "excellent"
  },
  {
    name: "Good",
    value: HomeConditionLevel.GOOD,
    description: "In good shape & well maintained",
    image: "good"
  },
  {
    name: "Minor Work",
    value: HomeConditionLevel.MINOR_WORK,
    description: "Needs a few minor renovations",
    image: "minor-work"
  },
  {
    name: "Major Work",
    value: HomeConditionLevel.MAJOR_WORK,
    description: "Needs major renovations for all",
    image: "major-work"
  }
];

@Component({
  selector: "app-que-condition-base",
  templateUrl: "./que-condition-base.component.html",
  styleUrls: ["./que-condition-base.component.scss"]
})
export class QueConditionBaseComponent extends QuestionCardDirective {
  homeConditionLevel: HomeConditionLevel | null;
  HomeConditionLevelLabel = HomeConditionLevelLabel;
  options = AREA_CONDITION_OPTIONS;

  question = "Tell us about the condition of the";
  conditionName = "Kitchen";
  felloVisitorVarKey: keyof FelloVisitorVariables = "kitchenCondition";

  constructor(
    public offerJourneyService: OfferJourneyService,
    @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string,
    protected globalTrackingEventService: GlobalTrackingEventService
  ) {
    super(offerJourneyService, taskId);
    this.homeConditionLevel = null;
  }

  ngOnInit(): void {
    this.homeConditionLevel = this.offerJourney.vars[this.felloVisitorVarKey]
      ? (this.offerJourney.vars[this.felloVisitorVarKey] as HomeConditionLevel)
      : null;
  }

  submit(option: AreaConditionOption): void {
    const vars: FelloVisitorVariables = {
      [this.felloVisitorVarKey]: option.value
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }
}

@Component({
  selector: "app-que-condition-kitchen",
  templateUrl: "./que-condition-base.component.html",
  styleUrls: ["./que-condition-base.component.scss"]
})
export class QueConditionKitchenComponent extends QueConditionBaseComponent {}

@Component({
  selector: "app-que-condition-bathroom",
  templateUrl: "./que-condition-base.component.html",
  styleUrls: ["./que-condition-base.component.scss"]
})
export class QueConditionBathroomComponent extends QueConditionBaseComponent {
  conditionName = "Primary bathroom";
  felloVisitorVarKey: keyof FelloVisitorVariables = "bathroomCondition";
}

@Component({
  selector: "app-que-condition-flooring",
  templateUrl: "./que-condition-base.component.html",
  styleUrls: ["./que-condition-base.component.scss"]
})
export class QueConditionFlooringComponent extends QueConditionBaseComponent {
  conditionName = "Flooring";
  felloVisitorVarKey: keyof FelloVisitorVariables = "flooringCondition";
}

@Component({
  selector: "app-que-condition-flooring",
  templateUrl: "./que-condition-base.component.html",
  styleUrls: ["./que-condition-base.component.scss"]
})
export class QueConditionAdditionalBathroomComponent extends QueConditionBaseComponent {
  conditionName = "Additional baths";
  felloVisitorVarKey: keyof FelloVisitorVariables = "additionalBathroomCondition";
}

@Component({
  selector: "app-que-condition-home-paint",
  templateUrl: "./que-condition-base.component.html",
  styleUrls: ["./que-condition-base.component.scss"]
})
export class QueConditionHomePaintComponent extends QueConditionBaseComponent {
  conditionName = "Interior paint";
  felloVisitorVarKey: keyof FelloVisitorVariables = "homePaintCondition";
}

@Component({
  selector: "app-que-condition-overall",
  templateUrl: "./overall-condition.component.html",
  styleUrls: ["./que-condition-base.component.scss"]
})
export class QueConditionOverallComponent extends QueConditionBaseComponent {
  conditionName = "Overall home";
  felloVisitorVarKey: keyof FelloVisitorVariables = "overallCondition";

  submit(option: AreaConditionOption): void {
    const vars: FelloVisitorVariables = {
      [this.felloVisitorVarKey]: option.value
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe(() => {
      this.globalTrackingEventService.trackCustomEvent(TrackedEvents.HOME_CONDITION_RECEIVED, {
        address: this.offerJourney?.vars?.address
      });
    });
  }
}
